<script lang="ts" setup>
import { onlyNumber } from '~/utils'

const { modelValue, onlyNumbers, size = 'lg' } = defineProps<{
  modelValue: string | number
  placeholder?: string
  rules?: Array<(value: string) => boolean | string>
  onlyNumbers?: boolean
  size?: 'md' | 'lg'
}>()

const emit = defineEmits(['update:modelValue'])
const value = ref()

function clickHandler(e: Event) {
  if (onlyNumbers) {
    onlyNumber(e)
  }
}

watch(() => modelValue, (newValue) => {
  value.value = newValue
}, { immediate: true })

watch(value, (newValue) => {
  emit('update:modelValue', newValue)
})
</script>

<template>
  <q-input
    v-model="value"
    class="base-input"
    :class="[`base-input-${size}`]"
    borderless
    :placeholder="placeholder"
    :rules="rules"
    @keypress="clickHandler"
  >
    <template #prepend>
      <i-app-search />
    </template>
    <template v-if="modelValue" #append>
      <i-app-close @click="value = ''" />
    </template>
  </q-input>
</template>
